import React from 'react'
export default function Navbar() {
    return (
        <>
            <nav className="navbar navbar-expand-lg navbar-dark bg-dark">
                <div className="container-fluid">
                    <a className="navbar-brand" style={{ fontSize: '22px' }} href="/">i-notes</a>
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse" id="navbarSupportedContent">
                        <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                        <li className="nav-item">
                                <a className="nav-link active" aria-current="page" href="MainWebPage">Home</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link active" aria-current="page" href="About">About</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link active" aria-current="page" href="Author">Author</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link active" aria-current="page" href="Contact">Contact </a>
                            </li>
                            <li class="nav-item dropdown">
                                <a className="nav-link dropdown-toggle" href="*" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                    Notes_Contributors
                                </a>
                                <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                                    <li style={{textAlign:"center"}}>  Bishal Paul</li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>

        </>
    )
}
